import axios from 'axios';

// 默认API基础URL
let apiBaseUrl = 'http://localhost:3000';

// 尝试从后端获取API配置
export const initApiConfig = async () => {
  try {
    // 首先尝试获取服务器提供的API配置
    // 仅在开发模式下使用静态URL，生产环境从当前域名读取API
    if (process.env.NODE_ENV === 'production') {
      // 生产环境下，默认API地址与当前站点同域
      apiBaseUrl = `${window.location.protocol}//${window.location.host}`;
    } else {
      // 开发环境下，尝试从API服务器获取配置
      try {
        const response = await axios.get('http://localhost:3000/api-config');
        if (response.data && response.data.apiBaseUrl) {
          apiBaseUrl = response.data.apiBaseUrl;
          console.log('加载API配置:', apiBaseUrl);
        }
      } catch (error) {
        console.warn('无法获取API配置，使用默认地址:', apiBaseUrl);
      }
    }
  } catch (error) {
    console.error('初始化API配置失败:', error);
  }
};

// 获取当前API基础URL
export const getApiBaseUrl = () => apiBaseUrl;

// 获取完整API URL
export const getApiUrl = (endpoint) => {
  return `${apiBaseUrl}${endpoint}`;
};

// 验证防伪码
export const verifyCode = async (code) => {
  const url = getApiUrl(`/api/verify/${code}`);
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('验证请求失败:', error);
    return { status: 'error', message: '验证服务异常，请稍后再试' };
  }
};

export default {
  initApiConfig,
  getApiBaseUrl,
  getApiUrl,
  verifyCode
};